import { graphql } from "gatsby";
import { Product, SeparateJetpassBooking, SimplifyGatsbyQuery } from "@parksandresorts/core";
import SiteConfigurationStore from "components/stores/site-configuration-store";
import styles from "./separate-jetpass-booking-block.module.less";

export default function SeparateJetpassBookingBlock(
  props: SimplifyGatsbyQuery<Queries.SeparateJetpassBookingBlockFragment> & {
    // The `jetpassProduct` is missing some properties here. This `Pick` is used to fake that we have them, making TypeScript happy.
    jetpassProduct: Pick<Product, "upsellRichText" | "productNameMyPages">;
  },
) {
  return (
    <section
      className={["block block--max-width-narrow block--padded", styles.section].join(" ")}
      data-contentful-id={props.contentful_id}
    >
      <SeparateJetpassBooking
        product={props.jetpassProduct}
        showOnlyToday={props.showOnlyToday}
        labels={{ heading: props.heading, paragraph: props.paragraph }}
        useNewCheckout={SiteConfigurationStore.siteConfiguration.useNewCheckout}
      />
    </section>
  );
}

export const fragmentSeparateJetpassBookingBlockBlock = graphql`
  fragment SeparateJetpassBookingBlock on ContentfulSeparateJetpassBookingBlock {
    contentful_id
    id
    heading
    paragraph {
      raw
    }
    jetpassProduct {
      ...ProductBlock
    }
    showOnlyToday
  }
`;
